module.exports = __webpack_public_path__ + "img/location-whitechapel.c52687df.svg";